import * as React from 'react';
import { connect } from 'react-redux';
import * as UserModule from './../../../Modules/UserModule';
import ResetPasswordConfirmForm from '../Forms/_ResetPasswordConfirmForm';

type Props = {
    history: any;
    match: {
        params: {
            token: string;
        };
    };
};

type ConnectedDispatch = {
    resetPasswordConfirm: Function;
};
type ConnectedProps = {
    userStore: UserModule.Types.UserStore;
};
type State = {
    //
};

class ResetPasswordConfirm extends React.Component<Props & ConnectedDispatch & ConnectedProps, State> {
    constructor(props: Props & ConnectedDispatch & ConnectedProps) {
        super(props);
        this.resetPasswordConfirm = this.resetPasswordConfirm.bind(this);
    }
    private async resetPasswordConfirm(formData: UserModule.Types.PasswordResetRequest) {
        formData.token = this.props.match.params.token;
        await this.props.resetPasswordConfirm(formData);
    }
    public componentDidMount() {
        const { userStore } = this.props;
        if (userStore.success && userStore.success.resetConfirmSuccess) {
            setTimeout(() => {
                this.props.history.push('/');
            }, 4000);
        }
    }
    public render() {
        return (
            <div className="login__inner">
                <h1>
                    GPS
                    <br />
                    <span>Tracking</span>
                </h1>
                <ResetPasswordConfirmForm onSubmit={this.resetPasswordConfirm} />
            </div>
        );
    }
}

function mapDispatchToProps(dispatch: any) {
    return {
        resetPasswordConfirm: (formData: UserModule.Types.PasswordResetRequest) => dispatch(UserModule.Actions.resetPasswordConfirm(formData))
    };
}
function mapStateToProps(state: any) {
    return {
        userStore: state.userStore
    };
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ResetPasswordConfirm) as React.ComponentClass<Props>;
// export default RestartPassword;



// WEBPACK FOOTER //
// ./src/components/UserSigning/ResetPasswordConfirm/_ResetPasswordConfirm.tsx